import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, OnChanges, SimpleChanges, Injector } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { BaseComponent } from 'src/app/common/base/base.component';
import { PendingResourcesType, Catalog, ResourceType, Roles, StatusResource } from 'src/app/common/enumerations/enumerations';
import { KeChecklistBuilderService } from 'src/app/components/kenable/ke-checklist-builder/ke-checklist-builder.service';
import { DisapprovalReasonComponent } from 'src/app/controls/disapproval-reason/disapproval-reason.component';
import { YesNoDialogComponent } from 'src/app/controls/yes-no-dialog/yes-no-dialog.component';
import { Link } from 'src/app/components/catalogs/navigation-links/link/link';
import { Note } from 'src/app/services/notes/note.model';
import { Organization } from 'src/app/services/organization/organization';
import { BeamlineShutterRelation, ResourceSummary, Resource, ResourceUserRelation, ResourceOrganization, BeamlineCatalog, ChangeSummary, BeamlineHistory } from 'src/app/components/catalogs/beamline-catalog/resource/resources';
import { ResourcesService } from 'src/app/components/catalogs/beamline-catalog/resource/resources.service';
import { TOCA } from 'src/app/components/catalogs/beamline-catalog/resource/toca';
import { Restriction } from 'src/app/controls/restrictions/services/restriction';
import { PrivilegeEnum } from 'src/app/common/enumerations/privilege-enum';
import { User } from 'src/app/components/catalogs/user-catalog/services/user';
import { CatalogModel } from '../../catalog-model';
import { CatalogService } from '../../catalog-service';
import { BranchlineComponent } from '../dialogs/branchline/branchline.component';
import { EndstationComponent } from '../dialogs/endstation/endstation.component';
import { FastValveSensorComponent } from '../dialogs/fast-valve-sensor/fast-valve-sensor.component';
import { NoteComponent } from '../dialogs/note/note.component';
import { OrganizationComponent } from '../dialogs/organization/organization.component';
import { ShieldingComponent } from '../dialogs/shielding/shielding.component';
import { VacuumComponent } from '../dialogs/vacuum/vacuum.component';
import { MessagePlaceholder } from 'src/app/common/models/placeholder';
import { firstValueFrom, Observable, Subscription } from 'rxjs';
import { MessageTypeEnum } from 'src/app/components/messages/services/message-banner.enums';
import { PVInfoService } from 'src/app/services/pv-info/pv-info.service';
import { FormControl } from '@angular/forms';
import { PV } from 'src/app/services/pv-info/pv-info';
import { RelatedLinkBase } from '../../navigation-links/link/related-link-base';
import { take } from 'rxjs/operators';
import { PendingResource } from 'src/app/services/pending-approvals/pending-approval';


@Component({
  selector: 'app-resource-details-new',
  templateUrl: './resource-details-new.component.html',
  styleUrls: ['./resource-details-new.component.scss']
})

export class ResourceDetailsNewComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {
  @Input() showChanges!: boolean;
  @Input() beamlineShutter?: BeamlineShutterRelation;
  @Input() beamlineShutterRelations?: BeamlineShutterRelation[];
  @Input() showHistory?: boolean;

  @Output() updateKE = new EventEmitter<any>();
  @Output() cancelAdd = new EventEmitter();
  @Output() showChangesChange = new EventEmitter<boolean>();
  @Output() createdPendingID = new EventEmitter<number>();
  @Output() selectionLoadFinished = new EventEmitter<void>();

  public resourceSummary?: ResourceSummary | null;
  public shutter?: Resource = new Resource();
  public beamline?: Resource = new Resource();
  public catalogModel!: CatalogModel;
  public RURAux!: ResourceUserRelation;

  public supervisors!: ResourceUserRelation[];

  public oldShutterName?: string;
  public oldBeamlineName?: string;

  public branchlineParent: any;
  public restrictionsParent: any;

  public modifying!: boolean;
  public deleting!: boolean;
  public adding!: boolean;

  public showApprove!: boolean;
  public approving = false;
  public showModifyButton!: boolean;
  public hasShutter!: boolean;
  public fieldRepeatedShutter!: boolean;
  public fieldRepeatedBeamline!: boolean;
  public showCancelButton!: boolean;
  public showChangesTOCA!: boolean;

  currentResourceSummary?: ResourceSummary | null;
  private selectionLoadVersion = 0;

  public displayedColumnsShielding: string[] = ['position', 'shieldingName', 'keText', 'visible', 'alsoRelated', 'isRSSD', 'windchillLinks'];
  public displayedColumnsVacuum: string[] = ['position', 'vacuumName', 'minPressure', 'maxPressure', 'channelName', 'location', 'alsoRelated'];
  public displayedColumnsOrganization: string[] = ['organizationName', 'endstation', 'branchline'];
  public displayedColumnsNote: string[] = ['note'];
  public displayedColumnsEndStation: string[] = ['endstation', 'absiTemplateType'];
  public displayedColumnsBranchline: string[] = ['branchline'];
  public displayedColumnsFastValveSensor: string[] = ['position', 'fvsName', 'keText'];
  public displayedColumnsTOCA: string[] = ['name'];

  public dataSourceRestriction: MatTableDataSource<Restriction> = new MatTableDataSource();
  public dataSourceShielding: MatTableDataSource<Resource> = new MatTableDataSource();
  public dataSourceVacuum: MatTableDataSource<Resource> = new MatTableDataSource();
  public dataSourceOrganization: MatTableDataSource<ResourceOrganization> = new MatTableDataSource();
  public dataSourceSupervisor: MatTableDataSource<ResourceUserRelation> = new MatTableDataSource();
  public dataSourceScientist: MatTableDataSource<ResourceUserRelation> = new MatTableDataSource();
  public dataSourceAlternateScientist: MatTableDataSource<ResourceUserRelation> = new MatTableDataSource();
  public dataSourceNote: MatTableDataSource<Note> = new MatTableDataSource();
  public dataSourceEndStation: MatTableDataSource<Resource> = new MatTableDataSource();
  public dataSourceBranchline: MatTableDataSource<Resource> = new MatTableDataSource();
  public dataSourceOtherLinks: MatTableDataSource<Link> = new MatTableDataSource();
  public dataSourceMEDrawing: MatTableDataSource<Link> = new MatTableDataSource();
  public dataSourceAPPhaseSpace: MatTableDataSource<Link> = new MatTableDataSource();
  public dataSourceSASurvey: MatTableDataSource<Link> = new MatTableDataSource();
  public dataSourceFastValveSensor: MatTableDataSource<Resource> = new MatTableDataSource();
  public dataSourceTOCA: MatTableDataSource<TOCA> = new MatTableDataSource();

  resourceType = ResourceType;
  sceLinks?: RelatedLinkBase[];

  resourceStatuses = [{ id: 1, name: 'Active' }, { id: 2, name: 'Commisioning' }, { id: 3, name: 'Decommissioned' }, { id: 4, name: 'Inactive' }];

  beamlineHistory?: BeamlineHistory[];

  shutterCtrl = new FormControl();
  beamlineCtrl = new FormControl();
  beamlineNameCtrl = new FormControl();
  extensionCtrl = new FormControl();
  statusCtrl = new FormControl();

  pssValue?: string;
  rssValue?: string;

  rssCtrl = new FormControl();
  pssCtrl = new FormControl();

  pVs?: PV[];
  pVsFiltered?: PV[];
  pVs$!: Observable<PV[]>;
  pVsSubs!: Subscription;

  isSharedChildenModified?: boolean;
  pendingSharedChangesRestrictionMessage?: string | null;

  formGroupSubs!: Subscription;

  catalog = Catalog;

  constructor(
    protected override injector: Injector,
    private resourceService: ResourcesService,
    private catalogService: CatalogService,
    private keBuilder: KeChecklistBuilderService,
    private pvService: PVInfoService
  ) {
    super(injector);
  }


  //#region Initialization
  ngOnChanges(changes: SimpleChanges): void {
    const selectionLoadVersion = ++this.selectionLoadVersion;
    this.reset();
    void this.getDetails(undefined, selectionLoadVersion);
    if (changes['showHistory']) {
      if (this.showHistory) {
        this.getHistory();
      }
    }
  }

  ngOnInit() {
    this.loadPVs();
    this.initializeForm();
  }

  /**
   * Builds the reactive form with beamline and shutter controls, disables it initially,
   * and clears all bound data sources.
   */
  initializeForm() {
    // Build form group with existing controls
    this.formGroup = this.formBuilder.group({
      shutterCtrl: this.shutterCtrl,
      beamlineCtrl: this.beamlineCtrl,
      beamlineNameCtrl: this.beamlineNameCtrl,
      extensionCtrl: this.extensionCtrl,
      statusCtrl: this.statusCtrl,
      rssCtrl: this.rssCtrl,
      pssCtrl: this.pssCtrl
    });

    // Disable form until data is ready, then clear state
    this.formGroup.disable();
    this.clear();
  }

  /**
   * Resets component state by clearing resources, data sources, and form controls.
   * Used when starting a new entry or discarding current edits.
   */
  clear() {
    // Reset auxiliary data and core models
    this.resetRURAuxData();
    this.shutter = new Resource();
    this.beamline = new Resource();
    this.catalogModel = new CatalogModel();
    this.supervisors = [];

    // Reinitialize all table data sources
    this.dataSourceRestriction = new MatTableDataSource();
    this.dataSourceShielding = new MatTableDataSource();
    this.dataSourceVacuum = new MatTableDataSource();
    this.dataSourceOrganization = new MatTableDataSource();
    this.dataSourceSupervisor = new MatTableDataSource();
    this.dataSourceScientist = new MatTableDataSource();
    this.dataSourceAlternateScientist = new MatTableDataSource();
    this.dataSourceNote = new MatTableDataSource();
    this.dataSourceEndStation = new MatTableDataSource();
    this.dataSourceBranchline = new MatTableDataSource();
    this.dataSourceOtherLinks = new MatTableDataSource();
    this.dataSourceMEDrawing = new MatTableDataSource();
    this.dataSourceAPPhaseSpace = new MatTableDataSource();
    this.dataSourceSASurvey = new MatTableDataSource();
    this.dataSourceFastValveSensor = new MatTableDataSource();
    this.dataSourceTOCA = new MatTableDataSource();

    // Clear all form controls
    this.formGroup.reset();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  //#endregion


  // #region Get Details

  /**
   * Initialize the form and load the appropriate resource data based on context.
   * Routes between existing, pending, and new resource modes and updates internal state.
   */
  async getDetails(beamlineCatalog?: BeamlineCatalog, selectionLoadVersion = this.selectionLoadVersion): Promise<void> {
    this.initializeForm();

    let beamlineId = this.beamlineShutter?.beamlineId;
    let hasPending = !!this.beamlineShutter?.pendingResources?.length;


    // Existing (approved) resource with a beamline ID
    if (beamlineId) {
      void this.getResourceSummary(selectionLoadVersion);
      return;
    }

    // No shutter context at all - clear the component state
    if (!this.beamlineShutter) {
      this.reset();
      await this.finishSelectionLoading(selectionLoadVersion);
      return;
    }

    // Entering add/edit mode for new or pending resources
    this.enterAddMode();

    if (hasPending) {
      // Pending resource changes to apply
      await this.createResourceSummary();
    } else {
      // Brand new resource - enable form for data entry
      this.formGroup.enable();
    }

    await this.finishSelectionLoading(selectionLoadVersion);
  }

  private async finishSelectionLoading(selectionLoadVersion = this.selectionLoadVersion): Promise<void> {
    if (selectionLoadVersion !== this.selectionLoadVersion) return;
    await new Promise<void>(resolve => requestAnimationFrame(() => requestAnimationFrame(() => resolve())));
    if (selectionLoadVersion !== this.selectionLoadVersion) return;
    this.selectionLoadFinished.emit();
  }

  private enterAddMode(): void {
    this.adding = true;
    this.showModifyButton = false;

    this.restrictionsParent = { list: this.dataSourceRestriction.data };
    this.branchlineParent = { list: this.dataSourceBranchline.data };
  }


  /**
   * Resets transient UI state flags and clears dirty status for the form.
   * Call before starting fresh workflows or after completing an operation.
   */
  reset() {
    // Reset workflow state flags
    // this.scrollToTop();
    this.adding = false;
    this.modifying = false;
    this.deleting = false;

    // Reset action buttons and validation flags
    this.showApprove = false;
    this.showModifyButton = false;
    this.showCancelButton = false;

    // Clear beamline/shutter-specific flags and change indicators
    this.hasShutter = false;
    this.fieldRepeatedShutter = false;
    this.fieldRepeatedBeamline = false;
    this.showChangesTOCA = false;
    // Mark form as clean
    this.setFormDirty(false);
  }

  gettingRS = false;


  /**
   * Fetch and load the appropriate resource summary based on the current view mode.
   * Routes to pending or approved summary loader and prevents concurrent requests.
   * @returns A promise that resolves when the summary is loaded.
   */
  async getResourceSummary(selectionLoadVersion = this.selectionLoadVersion): Promise<void> {
    // Bail out if a request is already in flight
    if (this.gettingRS) {
      setTimeout(() => void this.getResourceSummary(selectionLoadVersion), 50);
      return;
    }

    // Require a valid beamline context to proceed
    const beamlineId = this.beamlineShutter?.beamlineId;
    if (!beamlineId) {
      await this.finishSelectionLoading(selectionLoadVersion);
      return;
    }

    // Mark request in progress and ensure cleanup on completion or error
    this.gettingRS = true;
    try {
      // Route to appropriate loader based on current view mode
      if (this.showChanges) {
        await this.loadPendingResourceSummary(beamlineId);
      } else {
        await this.loadApprovedResourceSummary(beamlineId);
      }
    } finally {
      this.gettingRS = false;
      await this.finishSelectionLoading(selectionLoadVersion);
    }
  }

  /**
   * Load pending resource summary and snapshot the current approved state. Falls back to
   * approved view if no pending changes exist. Enriches summary with user information.
   * @param beamlineId the beamline identifier to fetch pending resources for.
   */
  private async loadPendingResourceSummary(beamlineId: number): Promise<void> {
    // Snapshot approved view before overlaying pending changes
    this.currentResourceSummary = await firstValueFrom(
      this.resourceService.getResourceSummaryByBeamline(beamlineId)
    );

    const hasPending = !!this.beamlineShutter?.pendingResources?.length;
    if (!hasPending) {
      // No pending resources found; disable changes view and load approved state
      this.showChangesChange.emit(false);
      this.showChanges = false; // Sync local state with emitted parent notification
      await this.loadApprovedResourceSummary(beamlineId);
      return;
    }

    // Fetch pending catalog model and populate pending resource summary
    const catalogModel = await firstValueFrom(
      this.catalogService.GetPendingCatalogById(beamlineId, Catalog.BeamlineCatalog)
    );

    this.resourceSummary = catalogModel?.resourceSummary ?? null;

    // Enrich summary with user details and validate row changes
    if (this.resourceSummary) {
      await this.enrichResourceSummary(this.resourceSummary);
      this.checkAddedAndDeletedRows();
    }
  }

  /**
   * Load and display approved (non-pending) resource summary. Creates a snapshot for
   * diffing against pending changes. Safeguards against stale results if view mode changed.
   * @param beamlineId the beamline identifier to fetch approved resources for.
   */
  private async loadApprovedResourceSummary(beamlineId: number): Promise<void> {
    const data = await firstValueFrom(
      this.resourceService.getResourceSummaryByBeamline(beamlineId)
    );

    // Discard stale results if user switched to pending view during the fetch
    if (!data || this.showChanges) return;

    // Populate and enrich the approved resource summary
    this.resourceSummary = data;
    await this.enrichResourceSummary(this.resourceSummary);

    // Create a deep copy as the baseline for detecting user changes
    this.currentResourceSummary = this.utils.cloneDeep(this.resourceSummary);

    // Validate integrity of shared child resource assignments (#6512)
    this.checkSharedChildren();
  }

  private async enrichResourceSummary(summary: ResourceSummary): Promise<void> {
    await this.addResourceSummaryInfo(summary);
    this.fillUserInfo(summary.alternateScientists ?? []);
    this.fillUserInfo(summary.scientists ?? []);
    this.fillUserInfo(summary.supervisors ?? []);
  }


  /**
 * Checks if shared children have been modified and generates a restriction message
 * listing the affected related beamlines.
 */
  private checkSharedChildren() {
    // Check if shared children have pending changes
    const sharedResources = (this.resourceSummary?.shieldings?.filter(s => s.pendingChangeIn) ?? []).concat(this.resourceSummary?.vacuums?.filter(b => b.pendingChangeIn) ?? []);

    this.isSharedChildenModified = (this.beamlineShutter?.hasSharedChanges && !this.beamlineShutter?.pendingResources?.length);
    if (this.isSharedChildenModified) {
      // Get IDs of other parent beamlines that share this resource
      var otherIDs = this.utils.JSONparse(this.beamlineShutter?.sharedParentIDs) as number[];
      // Build comma-separated list of other beamline names
      var otherResources = this.beamlineShutterRelations?.filter(r => otherIDs.includes(r.shutterId ?? 0))
        .map(r => r.beamlineName)
        .join(', ') ?? '';
      // Generate restriction message with current and related beamline names
      this.pendingSharedChangesRestrictionMessage =
        this.getMessage('PendingSharedChangesRestrictionMessage').description.replaceAll('{this}', this.beamlineShutter?.beamlineName ?? '').replaceAll('{other}', otherResources);
    }
  }

  /**
   * Creates and populates the resource summary from the most recent pending resource data.
   * Parses the stored JSON resource data and initializes the component state.
   */
  async createResourceSummary(): Promise<void> {
    // Get the last pending resource
    const pendingResource = this.beamlineShutter?.pendingResources?.at(-1);
    if (pendingResource?.resourceData) {
      // Parse and populate resource summary
      const data = this.utils.JSONparse(pendingResource.resourceData);
      await this.addResourceSummaryInfo(data);
      this.currentResourceSummary = this.utils.cloneDeep(this.resourceSummary);
    }
  }

  /**
   * Populates component with resource summary data including shutter, beamline, and all data sources.
   * Updates form controls and configures button visibility based on user permissions and pending changes.
   * @param data The resource summary containing all beamline resource information
   * @param showChanges Optional flag to control whether to populate drawing and survey data sources
   */
  async addResourceSummaryInfo(data: ResourceSummary, showChanges?: boolean): Promise<void> {
    this.resourceSummary = data as ResourceSummary;
    this.hasShutter = false;

    if (this.resourceSummary) {
      // Initialize shutter data and controls
      if (this.resourceSummary?.shutter) {
        this.shutter = this.resourceSummary.shutter as Resource;
        this.shutterCtrl.setValue(this.shutter.name);
        this.rssCtrl.setValue(this.shutter.rssChannelName);
        this.pssCtrl.setValue(this.shutter.pssChannelName);
        if (this.shutter?.name != null) {
          this.hasShutter = true;
        }
        if (!this.shutter) { this.shutter = new Resource(); }
      }
      else this.shutter = new Resource();
      this.rssValue = undefined;
      this.pssValue = undefined;
      this.getPVValues();

      // Initialize beamline data and controls
      this.beamline = this.resourceSummary.beamline as Resource;
      this.beamlineCtrl.setValue(this.beamline.name);
      this.beamlineNameCtrl.setValue(this.beamline.description);
      this.extensionCtrl.setValue(this.beamline.beamLineExtension);
      this.statusCtrl.setValue(this.beamline.statusResourceId);

      // Populate all table data sources
      if (!this.beamline) this.beamline = new Resource();

      // Populate table data sources for all related resources
      this.dataSourceEndStation = new MatTableDataSource(this.resourceSummary.endstations);
      this.dataSourceBranchline = new MatTableDataSource(this.resourceSummary.branchlines);
      this.dataSourceRestriction = new MatTableDataSource(this.resourceSummary.restrictions);
      this.dataSourceShielding = new MatTableDataSource(this.resourceSummary.shieldings?.sort((a, b) => this.utils.sort(a.position, b.position)));
      this.dataSourceVacuum = new MatTableDataSource(this.convertSciNotationToString(this.resourceSummary.vacuums as Resource[]));
      this.dataSourceOrganization = new MatTableDataSource(this.resourceSummary.organizations);
      this.dataSourceSupervisor = new MatTableDataSource(this.joinRURs(this.resourceSummary.supervisors));
      this.dataSourceScientist = new MatTableDataSource(this.joinRURs(this.resourceSummary.scientists));
      this.dataSourceAlternateScientist = new MatTableDataSource(this.joinRURs(this.resourceSummary.alternateScientists));
      this.dataSourceNote.data = this.resourceSummary.notes as Note[];
      this.dataSourceOtherLinks.data = this.resourceSummary.otherLinks ?? [];

      // Conditionally populate drawing and survey data sources
      if (!showChanges) { this.dataSourceMEDrawing.data = this.resourceSummary.meDrawing ?? []; }
      if (!showChanges) { this.dataSourceAPPhaseSpace.data = this.resourceSummary.apPhaseSpace ?? []; }
      if (!showChanges) { this.dataSourceSASurvey.data = this.resourceSummary.saSurvey ?? []; }
      this.dataSourceFastValveSensor.data = this.resourceSummary.fastValveSensors as Resource[];

      // Set parent references for nested data
      if (this.resourceSummary.branchlines || this.resourceSummary.branchlines != null) {
        this.branchlineParent = { list: this.resourceSummary.branchlines };
      }
      this.restrictionsParent = { list: this.resourceSummary.restrictions };
    }

    // Configure button visibility based on permissions and modification state
    this.showModifyButton = (this.isSA() || this.hasPrivilege(PrivilegeEnum.BeamlineCatalog)) && !this.resourceSummary.resourceChange?.modified && !this.resourceSummary.shieldingChange?.modified;
    this.showCancelButton = false;

    const pendingResource = this.catalogService.getLastPendingResource(this.beamlineShutter!, PendingResourcesType.Details);

    // Update permissions and change tracking for pending resources
    if (pendingResource) {
      this.showApprove = this.hasRoles([Roles.RP, Roles.SA]) && this.currentUser?.id != pendingResource.createdBy;
      this.showModifyButton = (this.isSA() || this.hasPrivilege(PrivilegeEnum.BeamlineCatalog)) && this.currentUser?.id == pendingResource.createdBy && this.showChanges;
      this.showCancelButton = (this.isSA() || this.hasPrivilege(PrivilegeEnum.BeamlineCatalog)) && this.currentUser?.id == pendingResource.createdBy && this.showChanges;
      // beamlineShutter.pendingResources may have stale approvedBy/shieldingApprovedBy since
      // BeamlineShutterState is not updated on approval. PendingResourcesState IS updated via
      // SignalR and on initial load, so merge from it as the authoritative source.
      const storePRs = this.store.selectSnapshot(state => state.PendingResources?.data) as PendingResource[];
      const storePR = storePRs?.find(p => p.id === pendingResource.id);
      const approvedBy = pendingResource.approvedBy ?? storePR?.approvedBy;
      const shieldingApprovedBy = pendingResource.shieldingApprovedBy ?? storePR?.shieldingApprovedBy;
      if (this.resourceSummary.resourceChange)
        this.resourceSummary.resourceChange.approved = !!approvedBy;
      if (this.resourceSummary.shieldingChange)
        this.resourceSummary.shieldingChange.approved = !!shieldingApprovedBy;
    }
    this.adding = false;
    await this.onShowChangesTOCA();
  }
  //#endregion


  // #region Save Methods
  /**
   * Validates and saves the beamline resource as a draft, either creating a new entry
   * or updating an existing one based on the modification state.
   */
  async saveResource() {
    // Validate form before proceeding
    if (await this.isValid()) {
      // Prepare catalog model with form data
      const catalogModel = new CatalogModel();
      catalogModel.resourceSummary = this.addInputDataToResourceSummary();

      // Create new draft or update existing resource
      if (!this.modifying) {
        this.catalogService.SaveAsDraft(catalogModel, Catalog.BeamlineCatalog).toPromise().then((data) => {
          if (data && data > 0)
            this.createdPendingID.emit(data);
          this.alert.message('beamline_Create_SentToApprove');
          this.reset();
          this.showChangesChange.emit(true);
        }).catch(() => {
          this.alert.defaultError();
        });
      } else {
        this.catalogService.SaveAsDraftType(catalogModel, Catalog.BeamlineCatalog, PendingResourcesType.Details).toPromise().then((data) => {
          this.reset();
          this.showChangesChange.emit(true);
          this.alert.message('beamline_Update_SentToApprove');
        }).catch(() => {
          this.alert.defaultError();
        });
      }
    }
  }

  /**
  * Collects and transforms input data from all data sources into a ResourceSummary object.
  * Applies transformations and validations to specific data types as needed.
  * @returns The populated ResourceSummary with all component data, or undefined if creation fails.
  */
  addInputDataToResourceSummary(): ResourceSummary | undefined {
    const resourceSummary = new ResourceSummary();

    // Helper to safely assign data or empty array
    const assignData = (source: any[], transformFn?: (data: any[]) => any[]) =>
      source?.length ? (transformFn ? transformFn(source) : source) : [];

    // Populate basic collections (endstations, branchlines, restrictions)
    resourceSummary.endstations = assignData(this.dataSourceEndStation.data);
    resourceSummary.branchlines = assignData(this.dataSourceBranchline.data);
    resourceSummary.restrictions = assignData(this.dataSourceRestriction.data);

    // Populate shieldings with position reordering
    resourceSummary.shieldings = assignData(this.dataSourceShielding.data, data => {
      this.reorderPositions(data);
      return data;
    });

    // Populate vacuums with position reordering and scientific notation conversion
    resourceSummary.vacuums = assignData(this.dataSourceVacuum.data, data => {
      this.reorderPositions(data);
      return this.convertSciNotationToNumber(data);
    });

    // Populate organization and personnel data with RUR assignments where needed
    resourceSummary.organizations = assignData(this.dataSourceOrganization.data);
    resourceSummary.supervisors = assignData(this.dataSourceSupervisor.data, data => this.addRURs(data));
    resourceSummary.scientists = assignData(this.dataSourceScientist.data, data => this.addRURs(data));
    resourceSummary.alternateScientists = assignData(this.dataSourceAlternateScientist.data, data => this.addRURs(data));

    // Populate additional metadata and documentation
    resourceSummary.notes = assignData(this.dataSourceNote.data);
    resourceSummary.fastValveSensors = assignData(this.dataSourceFastValveSensor.data);
    resourceSummary.otherLinks = assignData(this.dataSourceOtherLinks.data);
    // resourceSummary.toca = assignData(this.dataSourceTOCA.data);
    this.onShowChangesTOCA();

    resourceSummary.meDrawing = assignData(this.dataSourceMEDrawing.data);
    resourceSummary.apPhaseSpace = assignData(this.dataSourceAPPhaseSpace.data);
    resourceSummary.saSurvey = assignData(this.dataSourceSASurvey.data);

    // Populate core beamline components (shutter and beamline)
    if (this.shutter) {
      resourceSummary.shutter = this.createNewShutter(this.shutter);
    }

    if (this.beamline) {
      resourceSummary.beamline = this.createNewBeamline(this.beamline);
    }

    // Track changes and return the complete summary
    this.checkChanges(resourceSummary);
    return resourceSummary;
  }
  //#endregion

  /////////////////////////////////////////////
  //#region Other Methods

  getDataFromRestriction(restrictions: Restriction[]) {
    this.dataSourceRestriction.data = restrictions;
  }
  //#endregion


  //#region Dialogs

  /**
   * Opens a dialog to add a new endstation resource and validates it's not a duplicate
   * before adding to the data source.
   */
  openAddEndstationDialog() {
    // Configure and open the endstation dialog with new resource
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = new Resource();
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(EndstationComponent, dialogConfig);

    // Validate and add new endstation if not duplicate
    dialogRef.afterClosed().toPromise().then(data => {
      if (data) {
        if (this.isResourceRepeated(this.dataSourceEndStation.data, data, 'Endstation')) {
          this.addEndstation(data);
          this.setFormDirty();
        }
      }
    });
  }

  openEditEndstationDialog(endstation: Resource, index: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = this.utils.cloneDeep(endstation);
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(EndstationComponent, dialogConfig);
    dialogRef.afterClosed().toPromise().then((endstationUpdated: Resource) => {
      if (endstationUpdated) {
        this.dataSourceEndStation.data[index] = endstationUpdated;
        this.dataSourceEndStation.filter = '';
        this.updateResourceNames(endstationUpdated, endstation.name ?? '');
        this.setFormDirty();
      }
    });
  }

  openAddBranchlineDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = new Resource();
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(BranchlineComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        if (this.isResourceRepeated(this.dataSourceBranchline.data, data, 'Branchline')) {
          this.addBranchline(data);
          this.setFormDirty();
          this.branchlineParent = { list: this.dataSourceBranchline.data };
        }
      }
    });
  }

  /**
   * Opens a dialog to edit an existing branchline resource and updates the data source
   * with the modified values upon confirmation.
   * @param branchline - The branchline resource to edit
   * @param index - The position of the branchline in the data source array
   */
  openEditBranchlineDialog(branchline: Resource, index: number) {
    // Configure and open the branchline edit dialog
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = this.utils.cloneDeep(branchline);
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(BranchlineComponent, dialogConfig);

    // Handle dialog result and update data source
    dialogRef.afterClosed().toPromise().then((branchlineUpdated: Resource) => {
      if (branchlineUpdated) {
        this.dataSourceBranchline.data[index] = branchlineUpdated;
        this.dataSourceBranchline.filter = '';
        this.updateResourceNames(branchlineUpdated, branchline.name ?? '');
        this.setFormDirty();
      }
    });
  }

  /**
   * Opens a dialog to add a new shielding resource and validates it's not a duplicate
   * before adding to the data source.
   */
  openAddShieldingDialog() {
    // Configure and open the shielding dialog with new resource
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      resource: new Resource(),
      shutter: this.shutter
    };
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(ShieldingComponent, dialogConfig);

    // Validate and add new shielding if not duplicate
    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        if (this.isResourceRepeated(this.dataSourceShielding.data, data, 'Shielding')) {
          this.addShielding(data);
          this.setFormDirty();
        }
      }
    });
  }

  /**
   * Opens the shielding dialog in note mode so notes can be inserted with shielding ordering.
   */
  openAddShieldingNoteDialog() {
    // Shielding notes use the shielding dialog but save as a note resource type.
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      resource: { ...new Resource(), type: ResourceType.ShieldingNote, name: 'Note' },
      shutter: this.shutter
    };
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(ShieldingComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.addShielding(data);
        this.setFormDirty();
      }
    });
  }

  /**
   * Opens a dialog to edit an existing shielding resource and marks the form as dirty
   * if changes are made.
   * @param shielding - The shielding resource to edit
   */
  openEditShieldingDialog(shielding: Resource) {
    // Configure and open the shielding edit dialog
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      resource: shielding,
      shutter: this.shutter
    };
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(ShieldingComponent, dialogConfig);

    // Mark form dirty if changes were made
    dialogRef.afterClosed().subscribe(data => {
      if (data)
        this.setFormDirty();
    });
  }

  /**
   * Opens a dialog to add a new vacuum resource and validates it's not a duplicate
   * before adding to the data source.
   */
  openAddVacuumDialog() {
    // Configure and open the vacuum dialog with new resource
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      resource: new Resource(),
      shutter: this.shutter
    };
    dialogConfig.width = '500px';
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(VacuumComponent, dialogConfig);

    // Validate and add new vacuum if not duplicate
    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        if (this.isResourceRepeated(this.dataSourceVacuum.data, data, 'Vacuum')) {
          this.addVacuum(data);
          this.setFormDirty();
        }
      }
    });
  }

  /**
   * Opens a dialog to edit an existing vacuum resource and updates the data source
   * with the modified values.
   * @param vacuum - The vacuum resource to edit
   */
  openEditVacuumDialog(vacuum: Resource) {
    // Configure and open the vacuum edit dialog
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      resource: vacuum,
      shutter: this.shutter
    };
    dialogConfig.width = '500px';
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(VacuumComponent, dialogConfig);

    // Update data source with modified vacuum
    dialogRef.afterClosed().subscribe(data => {
      const index = this.dataSourceVacuum.data.findIndex(x => x.id == data.id);
      this.dataSourceVacuum.data[index] = data;
      this.setFormDirty();
    });
  }

  /**
   * Opens a dialog to add a new organization resource and validates it's not a duplicate
   * for the selected branchline and endstation combination before adding.
   */
  openAddOrganizationDialog() {
    // Configure and open the organization dialog with context data
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { resourceOrganization: new ResourceOrganization(), branchlines: this.dataSourceBranchline.data, endstations: this.dataSourceEndStation.data };
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(OrganizationComponent, dialogConfig);

    // Validate and add new organization if not duplicate
    dialogRef.afterClosed().subscribe((data: ResourceOrganization) => {
      // if (data && data.organization && data.branchline && data.endstation) {
      if (data && data.organization) {
        if (this.isOrganizationRepeted(this.dataSourceOrganization.data, data.organization, data.branchline, data.endstation)) {
          this.addOrganization(data);
          this.setFormDirty();
        }
      }
    });
  }

  openEditOrganizationDialog(resourceOrganization: ResourceOrganization, index: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = { resourceOrganization: this.utils.cloneDeep(resourceOrganization), branchlines: this.dataSourceBranchline.data, endstations: this.dataSourceEndStation.data };
    const dialogRef = this.dialog.open(OrganizationComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        if (this.isOrganizationRepeted(this.dataSourceOrganization.data, data.organization, data.branchline, data.endstation, resourceOrganization)) {
          this.dataSourceOrganization.data[index] = data;
          this.dataSourceOrganization.filter = '';
          this.setFormDirty();
        }
      }
    });
  }

  openAddNoteDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = new Note();
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(NoteComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.addNote(data);
        this.setFormDirty();
      }
    });
  }

  openEditNoteDialog(note: Note) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = note;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(NoteComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(() => {
      this.setFormDirty();
    });
  }

  openAddFastValveSensorDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = new Resource();
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(FastValveSensorComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(data => {
      if (data != null) {
        this.addFastValveSensor(data);
        this.setFormDirty();
      }
    });
  }

  openEditFastValveSensorDialog(fastValveSensor: Resource) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = fastValveSensor;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(FastValveSensorComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(() => {
      this.setFormDirty();
    });
  }

  openAddDisapprovalDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = '';
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DisapprovalReasonComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.disapprove(data);
      }
    });
  }
  //#endregion

  ///#region Add Methods
  addEndstation(data: Resource) {
    const endstation = this.createNewEndstation(this.dataSourceEndStation.data.length + 1, data);
    this.dataSourceEndStation.data.push(endstation);
    this.dataSourceEndStation.filter = '';
  }

  addBranchline(data: Resource) {
    const branchline = this.createNewBranchline(this.dataSourceBranchline.data.length + 1, data);
    this.dataSourceBranchline.data.push(branchline);
    this.dataSourceBranchline.filter = '';
  }

  addShielding(data: Resource) {
    const shielding = this.createNewShielding(this.dataSourceShielding.data.length + 1, data);
    this.dataSourceShielding.data.push(shielding);
    this.dataSourceShielding.filter = '';
  }

  addVacuum(data: Resource) {
    const vacuum = this.createNewVacuum(this.dataSourceVacuum.data.length + 1, data);
    this.dataSourceVacuum.data.push(vacuum);
    this.dataSourceVacuum.filter = '';
  }

  addOrganization(data: ResourceOrganization) {
    this.dataSourceOrganization.data.push(data);
    this.dataSourceOrganization.filter = '';
  }

  addNote(data: Note) {
    this.dataSourceNote.data.push(data);
    this.dataSourceNote.filter = '';
  }

  addFastValveSensor(data: Resource) {
    const fastValveSensor = this.createNewFastValveSensor(this.dataSourceFastValveSensor.data.length + 1, data);
    this.dataSourceFastValveSensor.data.push(fastValveSensor);
    this.dataSourceFastValveSensor.filter = '';
  }

  //#region Approve / Disapprove

  approve(role?: Roles) {
    if (this.approving) return;

    if (this.beamlineShutter?.pendingResources?.length) {
      const pendingResource = this.beamlineShutter.pendingResources.at(-1);
      if (pendingResource) {
        this.approving = true;
        this.catalogService.Approve(pendingResource.id, role != this.roleEnum.RP ? Catalog.BeamlineCatalog : Catalog.BLShielding, PendingResourcesType.Details).toPromise().then(savedId => {
          this.alert.message('beamline_Approved');
          if (role === this.roleEnum.RP) {
            pendingResource.shieldingApprovedBy = this.currentUser?.id;
          } else {
            pendingResource.approvedBy = this.currentUser?.id;
          }
          if (this.shutter?.id && savedId) {
            this.keBuilder.UpdateTemplatesAfterUpdate(this.shutter.id, savedId).toPromise().then(data => {
              const resources = data as Resource[];
              this.alert.message('beamline_KETemplates_Updated', [new MessagePlaceholder('{resources}', resources.filter(r => r.name).map(r => r.name).join(', '))], MessageTypeEnum.Info);
              this.reset();
            }).catch(() => {
              this.alert.defaultError();
            });
          } else {
            this.reset();
          }
        }).catch(() => {
          this.alert.defaultError();
        }).finally(() => {
          this.approving = false;
        });
      }
    }

  }

  disapprove(disapprovalReason: string) {
    if (this.beamlineShutter?.beamlineId)
      this.catalogService.Unapprove(this.beamlineShutter.beamlineId, Catalog.BeamlineCatalog, disapprovalReason, PendingResourcesType.Details).toPromise().then(() => {
        this.alert.message('beamline_Disapproved');
        this.reset();
      }).catch(() => {
        this.alert.defaultError();
      });
  }

  modifyResource() {
    this.showModifyButton = false;
    this.adding = false;
    this.deleting = false;
    this.modifying = true;
    this.formGroup.enable();
    this.setFormDirty(false);
  }

  //#region Delete Methods
  deleteEndstation(data: Resource) {
    this.dialogService.ConfirmationDialog('Remove', 'this <b>Endstation</b>').subscribe((result) => {
      if (result) {
        const index = this.dataSourceEndStation.data.indexOf(data);
        this.dataSourceEndStation.data.splice(index, 1);
        this.deleteResourceNames(data);
        this.deleteResourceNamesNtype(data);
        if (this.dataSourceEndStation.data.length > 0) {
          this.reorderPositions(this.dataSourceEndStation.data);
        }
        this.dataSourceEndStation.filter = '';
        this.setFormDirty();
      }
    });
  }

  deleteBranchline(data: Resource) {
    this.dialogService.ConfirmationDialog('Remove', 'this <b>Branchline</b>').subscribe((result) => {
      if (result) {
        const index = this.dataSourceBranchline.data.indexOf(data);
        this.dataSourceBranchline.data.splice(index, 1);
        this.deleteResourceNames(data);
        this.deleteResourceNamesNtype(data);
        if (this.dataSourceBranchline.data.length > 0) {
          this.reorderPositions(this.dataSourceBranchline.data);
        }
        this.dataSourceBranchline.filter = '';
        this.branchlineParent = { list: this.dataSourceBranchline.data };
        this.setFormDirty();
      }
    });
  }

  deleteShielding(data: Resource) {
    this.dialogService.ConfirmationDialog('Remove', 'this <b>Shielding</b>').subscribe((result) => {
      if (result) {
        const index = this.dataSourceShielding.data.indexOf(data);
        this.dataSourceShielding.data.splice(index, 1);
        if (this.dataSourceShielding.data.length > 0) {
          this.reorderPositions(this.dataSourceShielding.data);
        }
        this.dataSourceShielding.filter = '';
        this.setFormDirty();
      }
    });
  }

  deleteVacuum(data: Resource) {
    this.dialogService.ConfirmationDialog('Remove', 'this <b>Vacuum</b>').subscribe((result) => {
      if (result) {
        const index = this.dataSourceVacuum.data.indexOf(data);
        this.dataSourceVacuum.data.splice(index, 1);
        if (this.dataSourceVacuum.data.length > 0) {
          this.reorderPositions(this.dataSourceVacuum.data);
        }
        this.dataSourceVacuum.filter = '';
        this.setFormDirty();
      }
    });
  }

  deleteOrganization(data: ResourceOrganization) {
    this.dialogService.ConfirmationDialog('Remove', 'this <b>Organization</b>').subscribe((result) => {
      if (result) {
        const index = this.dataSourceOrganization.data.indexOf(data);
        this.dataSourceOrganization.data.splice(index, 1);
        this.dataSourceOrganization.filter = '';
        this.setFormDirty();
      }
    });
  }

  deleteNote(data: Note) {
    this.dialogService.ConfirmationDialog('Remove', 'this <b>Note</b>').subscribe((result) => {
      if (result) {
        const index = this.dataSourceNote.data.indexOf(data);
        this.dataSourceNote.data.splice(index, 1);
        this.dataSourceNote.filter = '';
        this.setFormDirty();
      }
    });
  }

  deleteFastValveSensor(data: Resource) {
    this.dialogService.ConfirmationDialog('Remove', 'this <b>Valve Sensor</b>').subscribe((result) => {
      if (result) {
        const index = this.dataSourceFastValveSensor.data.indexOf(data);
        this.dataSourceFastValveSensor.data.splice(index, 1);
        if (this.dataSourceFastValveSensor.data.length > 0) {
          this.reorderPositions(this.dataSourceFastValveSensor.data);
        }
        this.dataSourceFastValveSensor.filter = '';
        this.setFormDirty();
      }
    });
  }

  createNewEndstation(position: number, resource?: Resource): Resource {
    const endstationCreated: Resource = {
      id: 0,
      name: resource?.name,
      type: ResourceType.Endstation,
      position,
      status: 1,
      absiTemplateTypeID: resource?.absiTemplateTypeID,
      absiTemplateName: resource?.absiTemplateName
    };
    return endstationCreated;
  }

  //#region Create New Resource Methods
  createNewBranchline(position: number, resource?: Resource): Resource {
    const branchlineCreated: Resource = {
      id: 0,
      name: resource?.name,
      type: ResourceType.Branchline,
      position,
      status: 1,
    };
    return branchlineCreated;
  }

  createNewShielding(position: number, resource?: Resource): Resource {
    const shieldingCreated: Resource = {
      id: resource?.id ?? 0,
      name: resource?.name,
      type: resource?.type ?? ResourceType.Shielding,
      position,
      status: 1,
      keText: resource?.keText,
      checkboxVisible: resource?.type == ResourceType.ShieldingNote ? false : true,
      sharedWith: resource?.sharedWith,
      windchillLinks: resource?.windchillLinks,
    };
    return shieldingCreated;
  }

  createNewVacuum(position: number, resource?: Resource): Resource {
    const vacuumCreated: Resource = {
      id: resource?.id ?? 0,
      name: resource?.name,
      type: ResourceType.Vacuum,
      position,
      status: 1,
      keRequirement: resource?.keRequirement,
      channelName: resource?.channelName,
      location: resource?.location,
      keVacuumMaxRequirement: resource?.keVacuumMaxRequirement,
      keVacuumMinRequirement: resource?.keVacuumMinRequirement,
      MinPressureString: resource?.MinPressureString,
      MaxPressureString: resource?.MaxPressureString,
      sharedWith: resource?.sharedWith
    };
    return vacuumCreated;
  }

  createNewShutter(resource: Resource): Resource {
    const shutterCreated: Resource = {
      id: resource.id,
      name: resource.name,
      type: ResourceType.Shutter,
      status: 1,
      rssChannelName: resource.rssChannelName,
      pssChannelName: resource.pssChannelName,
      drawingPostLocation: resource.drawingPostLocation,
      rssRackLocation: resource.rssRackLocation,
      epsRackLocation: resource.epsRackLocation,
      fvsemLocation: resource.fvsemLocation
    };
    return shutterCreated;
  }

  createNewBeamline(resource: Resource): Resource {
    const beamlineCreated: Resource = {
      id: resource.id,
      name: resource.name,
      type: ResourceType.Beamline,
      status: 1,
      rssChannelName: resource.rssChannelName,
      pssChannelName: resource.pssChannelName,
      description: resource.description,
      beamLineExtension: resource.beamLineExtension,
      statusResourceId: resource.statusResourceId,
      sceLink: resource.sceLink
    };
    return beamlineCreated;
  }

  createNewFastValveSensor(position: number, resource?: Resource): Resource {
    const fastValveSensorCreated: Resource = {
      id: 0,
      name: resource?.name,
      type: ResourceType.FastValveSensor,
      position,
      status: 1,
      keText: resource?.keText,
    };
    return fastValveSensorCreated;
  }

  //#region Utility Methods

  /**
   * Displays sequential shielding numbers without counting inserted shielding notes.
   * @param shielding Shielding table row.
   * @param index Current row index in the shielding data source.
   * @returns Display number for shielding rows, or blank for notes.
   */
  getShieldingDisplayNumber(shielding: Resource, index: number): string {
    if (shielding.type == ResourceType.ShieldingNote)
      return '';

    // Notes keep their table position but do not consume a visible shielding number.
    return this.dataSourceShielding.data
      .slice(0, index + 1)
      .filter(item => item.type != ResourceType.ShieldingNote)
      .length
      .toString();
  }

  reorderPositions(resources: Resource[]) {
    let addPosition = 1;
    resources.map(element => {
      element.position = addPosition++;
    });
  }

  setShutterSelected() {
    if (this.shutter) {
      this.shutter.name = this.shutterCtrl.value;
      this.shutter = this.createNewShutter(this.shutter);
      this.formGroup.enable();
      this.updateResourceNames(this.shutter);
      this.hasShutter = true;
    } else {
      this.hasShutter = false;
      this.formGroup.disable();
    }
  }

  cancelChanges() {
    if (this.beamlineShutter?.pendingResources.length && this.catalogService.getLastPendingResource(this.beamlineShutter!, PendingResourcesType.Details)?.createdBy == this.currentUser?.id) {
      const pendingResource = this.beamlineShutter.pendingResources.at(-1);
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        message: 'Are you sure you want to Cancel you changes?',
        icon: 'question'
      };
      const dialogRef = this.dialog.open(YesNoDialogComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(data => {
        if (data && pendingResource?.id) {
          this.catalogService.CancelPending(pendingResource.id, Catalog.BeamlineCatalog, PendingResourcesType.Details).subscribe(() => {
            this.reset();
            this.alert.message('beamline_Disapproved');
          });
        }
      });
    }
    else {
      setTimeout(() => {
        this.reset();
      }, 300);
    }
  }

  cancel() {
    if (this.adding)
      this.cancelAdd.emit();
    this.modifying = false;
    this.adding = false;
    this.deleting = false;
    this.showCancelButton = false;
    this.setFormDirty(false);
  }

  reorderTable(event: any, dataSource: MatTableDataSource<any>) {
    if (this.adding || this.modifying) {
      moveItemInArray(dataSource.data, event.previousIndex, event.currentIndex);
      this.reorderPositions(dataSource.data);
      this.setFormDirty();
      dataSource.filter = '';
    }
  }

  getColumns(type: ResourceType) {
    switch (type) {
      case ResourceType.Shielding:
        // Shielding controls are available only when modifying an existing BL Catalog.
        return this.modifying ? this.displayedColumnsShielding.concat('add') : this.displayedColumnsShielding;
      case ResourceType.Vacuum:
        return (!this.adding && !this.modifying) ? this.displayedColumnsVacuum : this.displayedColumnsVacuum.concat('add');
      case ResourceType.Endstation:
        return (!this.adding && !this.modifying) ? this.displayedColumnsEndStation : this.displayedColumnsEndStation.concat('add');
      case ResourceType.Branchline:
        return (!this.adding && !this.modifying) ? this.displayedColumnsBranchline : this.displayedColumnsBranchline.concat('add');
      case ResourceType.FastValveSensor:
        return (!this.adding && !this.modifying) ? this.displayedColumnsFastValveSensor : this.displayedColumnsFastValveSensor.concat('add');
      case ResourceType.Note:
        return (!this.adding && !this.modifying) ? this.displayedColumnsNote : this.displayedColumnsNote.concat('add');
      case ResourceType.Organization:
        return (!this.adding && !this.modifying) ? this.displayedColumnsOrganization : this.displayedColumnsOrganization.concat('add');
      case ResourceType.TOCA:
        return (!this.adding && !this.modifying) ? this.displayedColumnsTOCA : this.displayedColumnsTOCA.concat('showChanges');
    }
    return [];
  }

  async isValid() {
    const resourceSummary: ResourceSummary = {
      shutter: this.shutter,
      beamline: this.beamline
    };
    const catalogModel: CatalogModel = {
      resourceSummary
    };
    if (!this.beamline?.name) {
      this.alert.message('beamline_Name_Required');
      return false;
    }

    if (!this.beamline.statusResourceId) {
      this.alert.message('beamline_Status_Required');
      return false;
    }
    if (this.beamline?.name || this.shutter?.name) {
      if (!this.beamline?.name) {
        this.alert.message('beamline_Name_Required');
        return false;
      }
      if (!this.beamline.statusResourceId) {
        this.alert.message('beamline_Status_Required');
        return false;
      }
      if (this.shutter?.name) {
        if (this.oldShutterName !== this.shutter?.name) {
          this.fieldRepeatedShutter = true;
        }
      }
    }

    return true;
  }

  /**
   * Validates the beamline name control for required and duplicate name checks.
   * Sets appropriate errors and flags if validation fails.
   */
  validateBeamline() {
    const raw = this.beamlineCtrl.value;
    const value = (typeof raw === 'string' ? raw : `${raw ?? ''}`).trim();

    // Check if required field is empty
    if (!value) {
      this.fieldRepeatedBeamline = false;
      this.beamlineCtrl.setErrors({ required: true });
      return;
    }

    const normalized = value.toLowerCase();

    // Get current record identifiers for comparison
    const currentBeamlineId = this.beamlineShutter?.beamlineId ?? null;
    const currentPendingId =
      this.beamlineShutter?.pendingResources?.at(-1)?.id ?? null;

    const isSameRecord = (bl: any) => {
      // Editing an existing beamline/shutter relation
      if (currentBeamlineId != null) {
        return bl.beamlineId === currentBeamlineId;
      }

      // Creating/pending scenario: fall back to pending resource identity
      const otherPendingId = bl.pendingResources?.at(-1)?.id ?? null;
      return otherPendingId != null && otherPendingId === currentPendingId;
    };

    const isDuplicateName = (bl: any) =>
      (bl.beamlineName ?? '').toString().trim().toLowerCase() === normalized;

    // Check for duplicate beamline name across other records
    const foundDuplicate = (this.beamlineShutterRelations ?? []).some(
      bl => isDuplicateName(bl) && !isSameRecord(bl)
    );

    if (foundDuplicate) {
      this.alert.message('beamline_Repeated');
      this.fieldRepeatedBeamline = true;
      this.beamlineCtrl.setErrors({ repeated: true });
      return;
    }

    // Clear errors if validation passes
    this.fieldRepeatedBeamline = false;
    this.beamlineCtrl.setErrors(null);
  }


  isResourceRepeated(resources: Resource[], resource: Resource, typeName: string) {
    if (resources.some(x => x.name?.toLowerCase() === resource.name?.toLowerCase())) {
      this.alert.message('resource_Added', [new MessagePlaceholder('{resourceTypeName}', typeName), new MessagePlaceholder('{resourceName}', resource.name?.toUpperCase())]);
      return false;
    }
    return true;
  }

  isOrganizationRepeted(resourceOrganizations: ResourceOrganization[], organization: Organization, branchline?: Resource, endstation?: Resource, oldResourceOrganization?: ResourceOrganization): boolean {
    let isOrganizationNameEqual: boolean = false;
    if (resourceOrganizations.some(resourceOrg => resourceOrg.organization?.name === organization.name && (resourceOrg.branchline?.name === branchline?.name || resourceOrg.endstation?.name === endstation?.name))) {
      if (oldResourceOrganization) { isOrganizationNameEqual = oldResourceOrganization.organization?.name === organization.name; }
      if (!isOrganizationNameEqual) {
        this.alert.message('organization_Added', [new MessagePlaceholder('{organizationName}', organization.name?.toUpperCase())]);
        return false;
      }
    }
    return true;
  }

  userChanged() {
    this.addInputDataToResourceSummary();
    this.setFormDirty();
  }

  //#endregion

  /**
   * Compares the current state against the provided summary and flags modifications.
   * Updates resource and shielding change metadata for approval workflows.
   * @param resourceSummary The assembled ResourceSummary to evaluate for differences.
   */
  checkChanges(resourceSummary: ResourceSummary) {
    this.resourceSummary = resourceSummary;
    // Initialize change flags; treat new beamline as modified
    let hasResourceChanges = (resourceSummary.beamline?.id ?? 0) == 0; // New beamline case
    let hasShieldingChanges = false;

    // Shutter field comparisons
    hasResourceChanges = hasResourceChanges || this.checkModified('shutter', 'name');

    hasResourceChanges = hasResourceChanges || this.checkModified('shutter', 'rssChannelName');
    hasResourceChanges = hasResourceChanges || this.checkModified('shutter', 'pssChannelName');
    hasResourceChanges = hasResourceChanges || this.checkModified('shutter', 'drawingPostLocation');
    hasResourceChanges = hasResourceChanges || this.checkModified('shutter', 'rssRackLocation');
    hasResourceChanges = hasResourceChanges || this.checkModified('shutter', 'epsRackLocation');
    hasResourceChanges = hasResourceChanges || this.checkModified('shutter', 'fvsemLocation');

    // Beamline field comparisons
    hasResourceChanges = hasResourceChanges || this.checkModified('beamline', 'name');
    hasResourceChanges = hasResourceChanges || this.checkModified('beamline', 'description');
    hasResourceChanges = hasResourceChanges || this.checkModified('beamline', 'beamLineExtension');
    hasResourceChanges = hasResourceChanges || this.checkModified('beamline', 'statusResourceId');
    hasResourceChanges = hasResourceChanges || this.checkModified('beamline', 'sceLink');

    // Summary collections and related entities
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'endstations');
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'branchlines');
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'restrictions');
    // hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'toca'); // TOCA changes are handled separately
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'vacuums');
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'organizations');
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'supervisors');
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'scientists');
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'alternateScientists');
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'notes');
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'meDrawing');
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'apPhaseSpace');
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'saSurvey');
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'otherLinks');
    hasResourceChanges = hasResourceChanges || this.checkModified('summary', 'fastValveSensors');

    // Shielding changes are tracked separately
    hasShieldingChanges = this.checkModified('summary', 'shieldings');

    // Update change metadata used by approval flow
    resourceSummary.resourceChange = {
      modified: hasResourceChanges,
      modifiedBy: hasResourceChanges ? this.getUserInfo(this.currentUser?.id) : null,
      modifiedOn: hasResourceChanges ? new Date() : null
    } as ChangeSummary;
    resourceSummary.shieldingChange = {
      modified: hasShieldingChanges,
      modifiedBy: hasShieldingChanges ? this.getUserInfo(this.currentUser?.id) : null,
      modifiedOn: hasShieldingChanges ? new Date() : null
    } as ChangeSummary;
  }

  updateResourceNames(resource: Resource, oldResourceName?: string) {
    if (this.dataSourceOrganization.data.length) {
      this.dataSourceOrganization.data.map(resourceOrg => {
        if (resource.type === ResourceType.Endstation && resourceOrg.endstation) {
          if (resourceOrg.endstation.id === resource.id) { resourceOrg.endstation = resource; }
          else if (resourceOrg.endstation.name === oldResourceName) { resourceOrg.endstation = resource; }
        }
        if (resource.type === ResourceType.Branchline && resourceOrg.branchline) {
          if (resourceOrg.branchline.id === resource.id) { resourceOrg.branchline = resource; }
          else if (resourceOrg.branchline.name === oldResourceName) { resourceOrg.branchline = resource; }
        }
      });
      this.dataSourceOrganization.filter = '';
    }
    if (oldResourceName) {
      this.dataSourceSupervisor.data = this.updateResourceNamesOfRURs(this.dataSourceSupervisor.data, resource, oldResourceName);
      this.dataSourceScientist.data = this.updateResourceNamesOfRURs(this.dataSourceScientist.data, resource, oldResourceName);
      this.dataSourceAlternateScientist.data = this.updateResourceNamesOfRURs(this.dataSourceAlternateScientist.data, resource, oldResourceName);
    }
    if (this.dataSourceRestriction.data.length) {
      this.dataSourceRestriction.data.map(x => {
        if (x.locationID) {
          if (x.locationID === resource.id) { x.location = resource; }
        } else if (x.location?.name === oldResourceName) { x.location = resource; }
      });
      this.dataSourceRestriction.filter = '';
    }
  }

  deleteResourceNames(resourceToDelete: Resource) {
    let index = -1;
    if (this.dataSourceOrganization.data.length) {
      this.dataSourceOrganization.data.map(resourceOrg => {
        if (resourceToDelete.type === ResourceType.Endstation && resourceOrg.endstation) {
          if (resourceOrg.endstation.id === resourceToDelete.id) { resourceOrg.endstation = new Resource(); }
          else if (resourceOrg.endstation.name === resourceToDelete.name) { resourceOrg.endstation = new Resource(); }
        }
        if (resourceToDelete.type === ResourceType.Branchline && resourceOrg.branchline) {
          if (resourceOrg.branchline.id === resourceToDelete.id) { resourceOrg.branchline = new Resource(); }
          else if (resourceOrg.branchline.name === resourceToDelete.name) { resourceOrg.branchline = new Resource(); }
        }
      });
      this.dataSourceOrganization.filter = '';
    }
    this.dataSourceSupervisor.data = this.joinRURs(this.addRURs(this.deleteResourceNamesOfRURs(this.dataSourceSupervisor.data, resourceToDelete)));
    this.dataSourceScientist.data = this.joinRURs(this.addRURs(this.deleteResourceNamesOfRURs(this.dataSourceScientist.data, resourceToDelete)));
    this.dataSourceAlternateScientist.data = this.joinRURs(this.addRURs(this.deleteResourceNamesOfRURs(this.dataSourceAlternateScientist.data, resourceToDelete)));

    if (this.dataSourceRestriction.data.length) {
      index = 0;
      this.dataSourceRestriction.data.map(x => {
        index++;
        if (x.locationID) {
          if (x.locationID === resourceToDelete.id) {
            this.dataSourceRestriction.data.splice(index - 1, 1);
          }
        }
      });
      this.dataSourceAlternateScientist.filter = '';
    }
  }

  deleteResourceNamesNtype(resource: Resource) {
    const matchResource = (item: any, key: string) =>
      item?.[key]?.name === resource.name && item?.[key]?.type === resource.type;

    const cleanDataSource = (
      dataSource: any,
      conditions: ((item: any) => boolean)[]
    ) => {
      dataSource.data = dataSource.data.filter((item: any) =>
        !conditions.some(cond => cond(item))
      );
      dataSource.filter = '';
    };

    if (this.dataSourceOrganization.data.length) {
      cleanDataSource(this.dataSourceOrganization, [
        x => !x.endstationId && matchResource(x, 'endstation'),
        x => !x.branchlineId && matchResource(x, 'branchline'),
      ]);
    }

    if (this.dataSourceSupervisor.data.length) {
      cleanDataSource(this.dataSourceSupervisor, [
        x => !x.endstationId && matchResource(x, 'endstation'),
        x => !x.branchlineId && matchResource(x, 'branchline'),
      ]);
    }

    if (this.dataSourceScientist.data.length) {
      cleanDataSource(this.dataSourceScientist, [
        x => x.endstationId && matchResource(x, 'endstation'),
        x => x.branchlineId && matchResource(x, 'branchline'),
      ]);
    }

    if (this.dataSourceAlternateScientist.data.length) {
      cleanDataSource(this.dataSourceAlternateScientist, [
        x => x.endstationId && matchResource(x, 'endstation'),
        x => x.branchlineId && matchResource(x, 'branchline'),
      ]);
    }

    if (this.dataSourceRestriction.data.length) {
      cleanDataSource(this.dataSourceRestriction, [
        x => !x.locationID && matchResource(x, 'location'),
      ]);
    }
  }


  addRURs(RURs: ResourceUserRelation[]): ResourceUserRelation[] {
    const RURsToSend: ResourceUserRelation[] = [];
    RURs.map(RURTable => {
      RURTable.resourceUserRelations?.map(RUR => {
        RURsToSend.push(RUR);
      });
    });
    return RURsToSend;
  }

  updateResourceUserRelations(dataSourceRUR: MatTableDataSource<ResourceUserRelation>, data: { resourceUserRlations: ResourceUserRelation[], user: User, endstationsList: string[], branchlinesList: string[]; }, index: number) {
    const RURToUpdate: ResourceUserRelation = {
      user: data.user,
      joinEndstations: data.endstationsList,
      joinBranchlines: data.branchlinesList,
      resourceUserRelations: data.resourceUserRlations
    };
    dataSourceRUR.data[index] = RURToUpdate;
    dataSourceRUR.filter = '';
  }

  joinRURs(resourceUserRelations?: ResourceUserRelation[]): ResourceUserRelation[] {
    let RURs = this.utils.cloneDeep(resourceUserRelations);
    if (RURs) {
      this.resetRURAuxData();
      let exit = false;
      const RURsJoined: ResourceUserRelation[] = [];
      if (RURs.length > 1) {
        do {
          for (let i = 0; i < RURs.length; i++) {
            if (RURs[0].user?.id === RURs[i].user?.id) {
              this.addInfoRUR(RURs, i);
            }
          }
          RURsJoined.push(this.RURAux);
          if (this.RURAux.user?.id)
            RURs = this.deleteRURsByUserId(this.RURAux.user.id, RURs);
          this.resetRURAuxData();
          if (RURs.length <= 1) {
            exit = true;
          }
        } while (!exit);
      }
      if (RURs.length === 1) {
        this.addInfoRUR(RURs, 0);
        RURsJoined.push(this.RURAux);
      }
      RURs = RURsJoined;
      return RURsJoined;
    }
    return [];
  }

  resetRURAuxData() {
    this.RURAux = new ResourceUserRelation();
    this.RURAux.resourceUserRelations = [];
    this.RURAux.joinEndstations = [];
    this.RURAux.joinBranchlines = [];
  }

  addInfoRUR(RURs: ResourceUserRelation[], position: number) {
    const RUR: ResourceUserRelation = {
      user: RURs[position].user,
      endstation: RURs[position].endstation,
      branchline: RURs[position].branchline,
      isAdded: RURs[position].isAdded,
      isDeleted: RURs[position].isDeleted,
      isModified: RURs[position].isModified,
    };
    this.RURAux.resourceUserRelations?.push(RUR);
    this.RURAux.user = RURs[position].user;
    this.RURAux.isAdded = RURs[position].isAdded;
    this.RURAux.isDeleted = RURs[position].isDeleted;
    const e = RURs[position].endstation?.name;
    if (e) {
      this.RURAux.joinEndstations?.push(e);
    }
    const b = RURs[position].branchline?.name;
    if (b) {
      this.RURAux.joinBranchlines?.push(b);
    }
  }

  deleteRURsByUserId(userId: number, RURs: ResourceUserRelation[]): ResourceUserRelation[] {
    for (let i = RURs.length - 1; i >= 0; i--) {
      if (RURs[i].user?.id === userId) {
        RURs.splice(i, 1);
      }
    }
    return RURs;
  }

  fillUserInfo(ur?: ResourceUserRelation[]) {
    ur?.map(u => {
      u.branchlineId = u.branchline?.id;
      u.endstationId = u.endstation?.id;
      u.resourceId = u.resource?.id;
      u.roleId = u.role?.id;
      u.userId = u.user?.id;
    });
  }

  convertSciNotationToString(vaccums: Resource[]): Resource[] {
    vaccums.map(data => {
      if (data.keVacuumMinRequirement === 0.0) {
        data.MinPressureString = '';
      } else {
        data.MinPressureString = data.keVacuumMinRequirement?.toPrecision(3).toString().replace('e', ' x 10').replace('-', '^-');
      }
      if (data.keVacuumMaxRequirement === 0.0) {
        data.MaxPressureString = '';
      } else {
        data.MaxPressureString = data.keVacuumMaxRequirement?.toPrecision(3).toString().replace('e', ' x 10').replace('-', '^-');
      }
    });
    return vaccums;
  }

  convertSciNotationToNumber(vaccums: Resource[]): Resource[] {
    vaccums.map(data => {
      if (data.MinPressureString) {
        data.keVacuumMinRequirement = +data.MinPressureString.replace(/\s/g, '').replace('x10', 'e').replace('^-', '-');
      } else {
        data.keVacuumMinRequirement = 0;
      }
      if (data.MaxPressureString) {
        data.keVacuumMaxRequirement = +data.MaxPressureString.replace(/\s/g, '').replace('x10', 'e').replace('^-', '-');
      } else {
        data.keVacuumMaxRequirement = 0;
      }
    });
    return vaccums;
  }

  async onShowChangesTOCA(): Promise<void> {
    if (!this.beamlineShutter?.beamlineId) return;

    try {
      const tocas = await firstValueFrom(
        this.resourceService.getTOCAChangesByResourceId(this.beamlineShutter.beamlineId, this.showChangesTOCA)
      );
      this.dataSourceTOCA.data = tocas ?? [];
    } catch (error) {
      console.error('Error loading TOCA changes', error);
      this.dataSourceTOCA.data = [];
    }
  }

  updateResourceNamesOfRURs(resourceUserRelations: ResourceUserRelation[], resourceUpdated: Resource, oldResourceName: string) {
    resourceUserRelations.map(x => {
      if (x.resourceUserRelations?.length) {
        x.resourceUserRelations.map(rur => {
          if (resourceUpdated.type === ResourceType.Endstation && rur.endstation?.name) {
            if (rur.endstation.id && rur.endstation.id === resourceUpdated.id) { rur.endstation = resourceUpdated; }
            else if (rur.endstation.name === oldResourceName) { rur.endstation = resourceUpdated; }
          }
          if (resourceUpdated.type === ResourceType.Branchline && rur.branchline?.name) {
            if (rur.branchline.id && rur.branchline.id === resourceUpdated.id) { rur.branchline = resourceUpdated; }
            else if (rur.branchline.name === oldResourceName) { rur.branchline = resourceUpdated; }
          }
        });
      }
    });
    resourceUserRelations = this.joinRURs(this.addRURs(resourceUserRelations));
    return resourceUserRelations;
  }

  deleteResourceNamesOfRURs(resourceUserRelations: ResourceUserRelation[], resourceToDelete: Resource) {
    resourceUserRelations.map(x => {
      if (x.resourceUserRelations?.length) {
        x.resourceUserRelations.map(rur => {
          if (resourceToDelete.type === ResourceType.Endstation && rur.endstation?.name) {
            if (rur.endstation.id && rur.endstation.id === resourceToDelete.id) { rur.endstation = new Resource(); }
            else if (rur.endstation.name === resourceToDelete.name) { rur.endstation = new Resource(); }
          }
          if (resourceToDelete.type === ResourceType.Branchline && rur.branchline?.name) {
            if (rur.branchline.id && rur.branchline.id === resourceToDelete.id) { rur.branchline = new Resource(); }
            else if (rur.branchline.name === resourceToDelete.name) { rur.branchline = new Resource(); }
          }
        });
      }
    });
    return resourceUserRelations;
  }

  /**
   * Compares the editable resource summary with its original state and marks changed rows.
   * @param resource Resource summary area being compared.
   * @param prop Property within the selected resource area.
   * @returns True when the selected value or collection contains changes.
   */
  checkModified(resource: string, prop: string) {
    if (this.resourceSummary && this.currentResourceSummary) {
      switch (resource) {
        case 'shutter':
          const shutter = this.resourceSummary.shutter ?? {} as Resource;
          const currentShutter = this.currentResourceSummary.shutter ?? {} as Resource;
          return (shutter as any)[prop] != (currentShutter as any)[prop];
          break;
        case 'beamline':
          if (typeof (this.resourceSummary.beamline as any)[prop] != 'object') {
            return (this.resourceSummary.beamline as any)[prop] != (this.currentResourceSummary.beamline as any)[prop];
          }
          else {
            const obj1 = (this.resourceSummary.beamline as any)[prop];
            const obj2 = (this.currentResourceSummary.beamline as any)[prop];
            return !this.utils.isEquivalent(obj1, obj2);
          }
          break;
        case 'summary':
          const sum1 = !this.resourceSummary ? [] : ((this.resourceSummary as any)?.[prop] as any[])?.sort((a, b) => this.utils.sort(a?.position ?? 0, b?.position ?? 0));
          const sum2 = ((this.currentResourceSummary as any)?.[prop] as any[])?.sort((a, b) => this.utils.sort(a?.position ?? 0, b?.position ?? 0));
          switch (prop) {
            case 'restrictions':
              sum1?.map((p: Restriction, i) => {
                const q = sum2?.[i] as Restriction;
                // Include every applicability flag so RSF-only changes are retained in the pending summary.
                if (!q || p.restrictionLanguage != q.restrictionLanguage || p.ebf != q.ebf || p.scf != q.scf || p.rsswa != q.rsswa || p.ppstb != q.ppstb || p.rsf != q.rsf || p.locationID != q.locationID)
                  p.isModified = true;
              });
              return sum1?.some(x => x.isModified) || sum1?.length != sum2?.length;
              break;
            case 'endstations':
              sum1?.map((p: Resource, i) => {
                const q = sum2?.[i] as Resource;
                if (!q || p.name != q.name || p.absiTemplateTypeID != q.absiTemplateTypeID)
                  p.isModified = true;
              });
              return sum1?.some(x => x.isModified) || sum1?.length != sum2?.length;
              break;
            case 'branchlines':
              sum1?.map((p: Resource, i) => {
                const q = sum2?.[i] as Resource;
                if (!q || p.name != q.name)
                  p.isModified = true;
              });
              return sum1?.some(x => x.isModified) || sum1?.length != sum2?.length;
              break;
            case 'toca':
              sum1?.map((p: Resource, i) => {
                const q = sum2?.[i] as Resource;
                if (!q || p.name != q.name)
                  p.isModified = true;
              });
              return sum1?.some(x => x.isModified) || sum1?.length != sum2?.length;
              break;
            case 'shieldings':
              sum1?.map((p: Resource, i) => {
                const q = sum2?.[i] as Resource;
                if (!q || p.name != q.name || p.keText != q.keText || p.position != q.position || p.checkboxVisible != q.checkboxVisible || p.isRSSD != q.isRSSD || !this.areWindchillLinksEqual(p.windchillLinks, q.windchillLinks))
                  p.isModified = true;
              });
              return sum1?.some(x => x.isModified) || sum1?.length != sum2?.length;
              break;
            case 'vacuums':
              sum1?.map((p: Resource, i) => {
                const q = sum2?.[i] as Resource;
                if (!q || p.name != q.name || p.keVacuumMinRequirement != q.keVacuumMinRequirement || p.keVacuumMaxRequirement != q.keVacuumMaxRequirement || p.channelName != q.channelName || p.location != q.location || p.position != q.position)
                  p.isModified = true;
              });
              return sum1?.some(x => x.isModified) || sum1?.length != sum2?.length;
              break;
            case 'organizations':
              sum1?.map((p: ResourceOrganization, i) => {
                const q = sum2?.[i] as ResourceOrganization;
                if (!q || p.organization?.id != q.organization?.id || p.endstation?.id != q.endstation?.id || p.branchline?.id != q.branchline?.id)
                  p.isModified = true;
              });
              return sum1?.some(x => x.isModified) || sum1?.length != sum2?.length;
              break;
            case 'notes':
              sum1?.map((p: Note, i) => {
                const q = sum2?.[i] as Note;
                if (!q || p.id != q.id || p.noteName != q.noteName)
                  p.isModified = true;
              });
              return sum1?.some(x => x.isModified) || sum1?.length != sum2?.length;
              break;
            case 'meDrawings':
              sum1?.map((p: Link, i) => {
                const q = sum2?.[i] as Link;
                if (!q || p.webAddress != q.webAddress || p.hyperlink != q.hyperlink)
                  p.isModified = true;
              });
              return sum1?.some(x => x.isModified) || sum1?.length != sum2?.length;
              break;
            case 'fastValveSensors':
              sum1?.map((p: Resource, i) => {
                const q = sum2?.[i] as Resource;
                if (!q || p.name != q.name || p.keText != q.keText || p.position != q.position)
                  p.isModified = true;
              });
              return sum1?.some(x => x.isModified) || sum1?.length != sum2?.length;
              break;
            case 'supervisors':
            case 'scientists':
            case 'alternateScientists':
              const getUserId = (x: any) => x.userId ?? x.user?.id;
              const getEndstationId = (x: any) => x.endstationId ?? x.endstation?.id;
              const getBranchlineId = (x: any) => x.branchlineId ?? x.branchline?.id;

              sum1?.sort((a, b) => getUserId(a) - getUserId(b));

              for (const p of sum1) {
                const q = sum2?.find(u =>
                  getUserId(u) === getUserId(p) &&
                  getEndstationId(u) === getEndstationId(p) &&
                  getBranchlineId(u) === getBranchlineId(p)
                );

                p.isModified = !q;
              }
              return sum1?.some(x => x.isModified) || sum1?.length !== sum2?.length;
              break;
          }
          return false;
      }
    }

    return false;
  }

  private areWindchillLinksEqual(a: Link[] | null | undefined, b: Link[] | null | undefined): boolean {
    // Treat null/undefined/empty as equivalent
    const arrA = a ?? [];
    const arrB = b ?? [];
    if (arrA.length !== arrB.length) return false;

    return arrA.every((linkA, i) => {
      const linkB = arrB[i];
      return linkA?.id === linkB?.id
        && linkA?.hyperlink === linkB?.hyperlink
        && linkA?.webAddress === linkB?.webAddress;
    });
  }

  isModified(resource: string, prop: string) {
    if (this.showChanges) {
      return this.checkModified(resource, prop);
    }
    return false;
  }
  override scrollToTop() {
    $('.main-panel').scrollTop(0);
  }

  loadPVs() {
    this.pVs$ = this.store.select(state => state.PV.data);
    this.pVsSubs = this.pVs$.subscribe(data => {
      if (data?.length) {
        this.pVs = data;
      }
    });
  }

  validateChannel(channel?: any, control?: FormControl, type?: string) {
    channel = control?.value;

    this.pvService.subscribe(channel).subscribe(data => {
      if (data)
        this.setValues(data.value, control, type, true);
    }, error => {
      control?.setErrors({ invalid: true });
      console.log(error);
    }
    );
  }

  getPVValues() {
    this.setValues(this.pVs?.find(p => p.pvName == this.shutter?.rssChannelName)?.value, this.rssCtrl, 'rss');
    this.setValues(this.pVs?.find(p => p.pvName == this.shutter?.pssChannelName)?.value, this.pssCtrl, 'pss');
  }

  setValues(value?: string, control?: FormControl, type?: string, validate?: boolean) {
    if (!value?.includes('ERROR')) {
      control?.setErrors(null);
      if (validate) this.setFormDirty();
      if (type == 'rss' && this.shutter) {
        this.rssValue = value == '1' ? 'Online' : 'Offline';
        this.shutter.rssChannelName = control?.value;
      }
      if (type == 'pss' && this.shutter) {
        this.pssValue = value == '1' ? 'Open' : 'Closed';
        this.shutter.pssChannelName = control?.value;
      }
    }
    else {
      type == 'rss' ? this.rssValue = 'ERROR!' : this.pssValue = 'ERROR!';
      control?.setErrors({ invalid: true, message: 'Invalid Channel Name!' });
    }
  }

  historyIDs?: number[];

  getHistory() {
    this.historyIDs = this.beamlineShutter?.historyIDs;
  }

  beamlineCatalog?: BeamlineCatalog;

  selectedHistory(beamlineCatalog: BeamlineCatalog) {
    this.shutter = beamlineCatalog.details.shutter;
    this.beamline = beamlineCatalog.details.beamline;

    this.beamlineCatalog = beamlineCatalog;


    // in history, currentResourceSumary is actually the previous one
    this.currentResourceSummary = null;
    this.currentResourceSummary = beamlineCatalog.details;

    if (this.beamlineCatalog.noDataFound) {
      this.alert.warning("No Detailed Data found for this Modification!");
    }

    this.showChanges = true;
    this.addResourceSummaryInfo(beamlineCatalog.pendingDetails, true);
    this.checkAddedAndDeletedRows();
  }

  checkAddedAndDeletedRows() {
    if (this.showHistory || this.showChanges) {
      // Restrictions
      const currentRestrictions = this.resourceSummary?.restrictions ?? [];
      const prevRestrictions = this.currentResourceSummary?.restrictions ?? [];

      if (currentRestrictions && prevRestrictions) {
        prevRestrictions.map(p => {
          if (p.id && !currentRestrictions.find(c => c.id == p.id)) {
            p.isDeleted = true;
            currentRestrictions.push(p);
          }
        });
      }
      currentRestrictions?.filter(c => !c.isDeleted).map(c => {
        c.isAdded = c.id == 0 || !prevRestrictions?.find(p => p.id == c.id);
      });

      //Endstations
      const currentEndstations = this.resourceSummary?.endstations ?? [];
      const prevEndstations = this.currentResourceSummary?.endstations ?? [];

      if (currentEndstations && prevEndstations) {
        prevEndstations.map(p => {
          if (p.id && !currentEndstations.find(c => c.id == p.id)) {
            p.isDeleted = true;
            currentEndstations.push(p);
          }
        });
      }
      currentEndstations?.filter(c => !c.isDeleted).map(c => {
        c.isAdded = c.id == 0 || !prevEndstations?.find(p => p.id == c.id);
      });

      // Branchlines
      const currentBranchlines = this.resourceSummary?.branchlines ?? [];
      const prevBranchlines = this.currentResourceSummary?.branchlines ?? [];

      if (currentBranchlines && prevBranchlines) {
        prevBranchlines.map(p => {
          if (p.id && !currentBranchlines.find(c => c.id == p.id)) {
            p.isDeleted = true;
            currentBranchlines.push(p);
          }
        });
      }
      currentBranchlines?.filter(c => !c.isDeleted).map(c => {
        c.isAdded = c.id == 0 || !prevBranchlines?.find(p => p.id == c.id);
      });

      //Shieldings
      const currentShieldings = this.resourceSummary?.shieldings ?? [];
      const prevShieldings = this.currentResourceSummary?.shieldings ?? [];

      if (!this.currentResourceSummary?.shieldingChange?.approvedBy) {
        if (currentShieldings && prevShieldings) {
          prevShieldings.map(p => {
            if (p.id >= 0 && !currentShieldings.find(c => c.id == p.id)) {
              p.isDeleted = true;
              currentShieldings.push(p);
            }
          });
        }
        currentShieldings?.filter(c => !c.isDeleted).map(c => {
          c.isAdded = c.id == 0 || !prevShieldings?.find(p => p.id == c.id);
        });
      }
      // Vacuum
      const currentVacuums = this.resourceSummary?.vacuums ?? [];
      const prevVacuums = this.currentResourceSummary?.vacuums ?? [];

      if (currentVacuums && prevVacuums) {
        prevVacuums.map(p => {
          if (p.id && !currentVacuums.find(c => c.id == p.id)) {
            p.isDeleted = true;
            currentVacuums.push(p);
          }
        });
      }
      currentVacuums?.filter(c => !c.isDeleted).map(c => {
        c.isAdded = c.id == 0 || !prevVacuums?.find(p => p.id == c.id);
      });

      //Organizations
      const currentOrganizations = this.resourceSummary?.organizations ?? [];
      const prevOrganizations = this.currentResourceSummary?.organizations ?? [];

      if (currentOrganizations && prevOrganizations) {
        prevOrganizations.map(p => {
          if (p.id && !currentOrganizations.find(c => c.id == p.id)) {
            p.isDeleted = true;
            currentOrganizations.push(p);
          }
        });
      }
      currentOrganizations?.filter(c => !c.isDeleted).map(c => {
        c.isAdded = c.id == 0 || !prevOrganizations?.find(p => p.id == c.id);
      });

      //Supervisors
      const currentSupervisors = this.resourceSummary?.supervisors ?? [];
      const prevSupervisors = this.currentResourceSummary?.supervisors ?? [];

      if (currentSupervisors && prevSupervisors) {
        prevSupervisors.map(p => {
          p.userId = p.user?.id;
          if (p.user?.id && !currentSupervisors.find(c => c.user?.id == p.user?.id)) {
            p.isDeleted = true;
            currentSupervisors.push(p);
          }
        });
      }
      currentSupervisors?.filter(c => !c.isDeleted).map(c => {
        c.userId = c.user?.id;
        c.isAdded = c.user?.id == 0 || !prevSupervisors?.find(p => p.user?.id == c.user?.id);
      });

      //BL Scientists
      const currentScientists = this.resourceSummary?.scientists ?? [];
      const prevScientists = this.currentResourceSummary?.scientists ?? [];

      if (currentScientists && prevScientists) {
        prevScientists.map(p => {
          p.userId = p.user?.id;
          if (p.user?.id && !currentScientists.find(c => c.user?.id == p.user?.id)) {
            p.isDeleted = true;
            currentScientists.push(p);
          }
        });
      }
      currentScientists?.filter(c => !c.isDeleted).map(c => {
        c.userId = c.user?.id;
        c.isAdded = c.user?.id == 0 || !prevScientists?.find(p => p.user?.id == c.user?.id);
      });

      //Alternate BL Scientists
      const currentAlternateScientists = this.resourceSummary?.alternateScientists ?? [];
      const prevAlternateScientists = this.currentResourceSummary?.alternateScientists ?? [];

      if (currentAlternateScientists && prevAlternateScientists) {
        prevAlternateScientists.map(p => {
          p.userId = p.user?.id;
          if (p.user?.id && !currentAlternateScientists.find(c => c.user?.id == p.user?.id)) {
            p.isDeleted = true;
            currentAlternateScientists.push(p);
          }
        });
      }
      currentAlternateScientists?.filter(c => !c.isDeleted).map(c => {
        c.isAdded = c.user?.id == 0 || !prevAlternateScientists?.find(p => p.user?.id == c.user?.id);
      });

      //Notes
      const currentNotes = this.resourceSummary?.notes ?? [];
      const prevNotes = this.currentResourceSummary?.notes ?? [];

      if (currentNotes && prevNotes) {
        prevNotes.map(p => {
          if (p.id && !currentNotes.find(c => c.id == p.id)) {
            p.isDeleted = true;
            currentNotes.push(p);
          }
        });
      }
      currentNotes?.filter(c => !c.isDeleted).map(c => {
        c.isAdded = c.id == 0 || !prevNotes?.find(p => p.id == c.id);
      });

      //Other Links
      const currentOtherLinks = this.resourceSummary?.otherLinks ?? [];
      const prevOtherLinks = this.currentResourceSummary?.otherLinks ?? [];

      if (currentOtherLinks && prevOtherLinks) {
        prevOtherLinks.map(p => {
          if (p.id && !currentOtherLinks.find(c => c.id == p.id)) {
            p.isDeleted = true;
            currentOtherLinks.push(p);
          }
        });
      }
      currentOtherLinks?.filter(c => !c.isDeleted).map(c => {
        c.isAdded = c.id == 0 || !prevOtherLinks?.find(p => p.id == c.id);
      });

      // ME Drawing Links
      const currentMeDrawings = this.resourceSummary?.meDrawing ?? [];
      const prevMeDrawings = this.currentResourceSummary?.meDrawing ?? [];

      if (currentMeDrawings && prevMeDrawings) {
        prevMeDrawings.map(p => {
          if (p.id && !currentMeDrawings.find(c => c.id == p.id)) {
            p.isDeleted = true;
            currentMeDrawings.push(p);
          }
        });
      }
      currentMeDrawings?.filter(c => !c.isDeleted).map(c => {
        c.isAdded = c.id == 0 || !prevMeDrawings?.find(p => p.id == c.id);
      });

      // AP PhaseSpace Link
      const currentAPPhaseSpace = this.resourceSummary?.apPhaseSpace ?? [];
      const prevAPPhaseSpace = this.currentResourceSummary?.apPhaseSpace ?? [];

      if (currentAPPhaseSpace && prevAPPhaseSpace) {
        prevAPPhaseSpace.map(p => {
          if (p.id && !currentAPPhaseSpace.find(c => c.id == p.id)) {
            p.isDeleted = true;
            currentAPPhaseSpace.push(p);
          }
        });
      }
      currentAPPhaseSpace?.filter(c => !c.isDeleted).map(c => {
        c.isAdded = c.id == 0 || !prevAPPhaseSpace?.find(p => p.id == c.id);
      });

      //SA Survey Links
      const currentSASurveys = this.resourceSummary?.saSurvey ?? [];
      const prevSASurveys = this.currentResourceSummary?.saSurvey ?? [];

      if (currentSASurveys && prevSASurveys) {
        prevSASurveys.map(p => {
          if (p.id && !currentSASurveys.find(c => c.id == p.id)) {
            p.isDeleted = true;
            currentSASurveys.push(p);
          }
        });
      }
      currentSASurveys?.filter(c => !c.isDeleted).map(c => {
        c.isAdded = c.id == 0 || !prevSASurveys?.find(p => p.id == c.id);
      });


      //Fast Valve Sensors
      const currentFastValveSensors = this.resourceSummary?.fastValveSensors ?? [];
      const prevFastValveSensors = this.currentResourceSummary?.fastValveSensors ?? [];

      if (currentFastValveSensors && prevFastValveSensors) {
        prevFastValveSensors.map(p => {
          if (p.id && !currentFastValveSensors.find(c => c.id == p.id)) {
            p.isDeleted = true;
            currentFastValveSensors.push(p);
          }
        });
      }
      currentFastValveSensors?.filter(c => !c.isDeleted).map(c => {
        c.isAdded = c.id == 0 || !prevFastValveSensors?.find(p => p.id == c.id);
      });
    }
  }

  setSCELink(e: RelatedLinkBase[]) {
    this.beamline!.sceLink = this.utils.JSONstringify(e);
    this.setFormDirty();
  }

  statusChange(): void {
    if (!this.beamline) { return; }

    const isDecomm = this.statusCtrl.value === StatusResource.Decommissioned;
    if (isDecomm) {
      this.confirmDecommission()
        .pipe(take(1))
        .subscribe(confirmed => {
          if (confirmed) {
            this.applyDecommission();
          } else {
            this.statusCtrl.setValue(this.beamline!.statusResourceId);
          }
        });
      return;
    }

    // regular status change
    this.beamline.statusResourceId = this.statusCtrl.value;
    this.setFormDirty();
  }

  // dialog helper
  private confirmDecommission(): Observable<boolean> {
    const dialogRef = this.dialog.open(YesNoDialogComponent, {
      width: '500px',
      data: {
        message: this.getMessage('BLCatalog_DecommissionMessage')?.description,
        icon: 'warn',
      },
    });

    return dialogRef.afterClosed() as Observable<boolean>;
  }

  // decommission workflow
  private applyDecommission(): void {
    this.beamline!.statusResourceId = this.statusCtrl.value;

    this.resetBeamline();
    this.deleteAllBranchlines();
    this.deleteAllEndstations();

    this.addInputDataToResourceSummary();
    this.setFormDirty();
  }

  // reset helpers
  private resetBeamline(): void {
    this.beamlineNameCtrl.setValue(null);
    this.beamline!.description = null;

    this.extensionCtrl.setValue(null);
    this.beamline!.beamLineExtension = null;

    this.beamline!.sceLink = null;

    const dataSources = [
      this.dataSourceRestriction,
      this.dataSourceShielding,
      this.dataSourceVacuum,
      this.dataSourceFastValveSensor,
      this.dataSourceNote,
      this.dataSourceOrganization,
      this.dataSourceOtherLinks,
      this.dataSourceSupervisor,
      this.dataSourceScientist,
      this.dataSourceAlternateScientist,

      // TOCAs and related DCC Links are intentionally retained - they should be handled on BRATOI catalog
      // this.dataSourceMEDrawing,
      // this.dataSourceAPPhaseSpace,
      // this.dataSourceSASurvey,
      // this.dataSourceTOCA,
    ];
    dataSources.forEach(ds => this.clearDataSource(ds as MatTableDataSource<unknown>));
    // Update restriction component
    this.restrictionsParent = { list: this.dataSourceRestriction.data };

    this.resetShutter();
  }

  private resetShutter(): void {
    if (!this.shutter) { return; }

    this.shutter.rssRackLocation = null;
    this.shutter.epsRackLocation = null;
    this.shutter.drawingPostLocation = null;
    this.shutter.fvsemLocation = null;
    this.shutter.rssChannelName = null;
    this.shutter.pssChannelName = null;

    this.rssCtrl.setValue(null);
    this.pssCtrl.setValue(null);
  }

  // generic clear
  private clearDataSource<T>(src: MatTableDataSource<T>): void {
    src.data.splice(0);
    src.filter = '';
  }

  // branch/endstation deletion
  private deleteAllBranchlines(): void {
    this.dataSourceBranchline.data.forEach(ds => {
      this.deleteResourceNames(ds);
      this.deleteResourceNamesNtype(ds);
    });
    this.clearDataSource(this.dataSourceBranchline);
  }

  private deleteAllEndstations(): void {
    this.dataSourceEndStation.data.forEach(ds => {
      this.deleteResourceNames(ds);
      this.deleteResourceNamesNtype(ds);
    });
    this.clearDataSource(this.dataSourceEndStation);
  }

  disableRPApproveForNewBeamline() {
    if (this.resourceSummary?.beamline?.id === 0 && !this.resourceSummary.resourceChange?.approved) {
      return true;
    }
    return false;
  }

  isApproveDisabled(): boolean {
    return !this.hasRoles([this.roleEnum.RP]) || this.disableRPApproveForNewBeamline();
  }

  getApproveTooltip(): string {
    if (!this.hasRoles([this.roleEnum.RP])) return 'Requires RP role.';
    if (this.disableRPApproveForNewBeamline()) return 'Approve is disabled until Beamline is approved by SA.';
    return 'Approve shielding change as RP.';
  }


}
